import { MutationCache, QueryClient } from "@tanstack/react-query";

import { ApiError } from "../types";

export function shouldRetry(failureCount: number, error: Error): boolean {
  const apiError = error as Partial<ApiError>;
  return (
    failureCount < 2 && (apiError.kind === "network" || apiError.kind === "server")
  );
}

export function createQueryClient(): QueryClient {
  let client: QueryClient;
  const mutationCache = new MutationCache({
    onSuccess: () => {
      if (typeof BroadcastChannel !== "undefined") {
        const channel = new BroadcastChannel("celsus-server-state");
        channel.postMessage("changed");
        channel.close();
      }
    },
  });
  client = new QueryClient({
    mutationCache,
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        retryDelay: (attempt: number) => Math.min(500 * 2 ** attempt, 2000),
        refetchOnWindowFocus: true,
      },
      mutations: { retry: false },
    },
  });
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel("celsus-server-state");
    channel.addEventListener("message", () => void client.invalidateQueries());
  }
  return client;
}

export const queryClient = createQueryClient();
